var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#AAB0B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.25C3.75 8.53125 5.13672 7.125 6.875 7.125H8.75C9.08203 7.125 9.375 7.41797 9.375 7.75C9.375 8.10156 9.08203 8.375 8.75 8.375H6.875C5.82031 8.375 5 9.21484 5 10.25C5 11.2852 5.82031 12.125 6.875 12.125H8.75C9.08203 12.125 9.375 12.418 9.375 12.75C9.375 13.1016 9.08203 13.375 8.75 13.375H6.875C5.13672 13.375 3.75 11.9883 3.75 10.25ZM13.125 13.375H11.25C10.8984 13.375 10.625 13.1016 10.625 12.75C10.625 12.418 10.8984 12.125 11.25 12.125H13.125C14.1602 12.125 15 11.2852 15 10.25C15 9.21484 14.1602 8.375 13.125 8.375H11.25C10.8984 8.375 10.625 8.10156 10.625 7.75C10.625 7.41797 10.8984 7.125 11.25 7.125H13.125C14.8438 7.125 16.25 8.53125 16.25 10.25C16.25 11.9883 14.8438 13.375 13.125 13.375ZM11.875 9.625C12.207 9.625 12.5 9.91797 12.5 10.25C12.5 10.6016 12.207 10.875 11.875 10.875H8.125C7.77344 10.875 7.5 10.6016 7.5 10.25C7.5 9.91797 7.77344 9.625 8.125 9.625H11.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCircle);
export default __webpack_public_path__ + "static/media/link-circle.a5970950.svg";
export { ForwardRef as ReactComponent };